export default {
  APP_SET_ENTITY_ID: "APP_SET_ENTITY_ID",
  UPDATE_WALLET_DATA: "UPDATE_WALLET_DATA",
  SET_WALLET_FETCH_STATE: "SET_WALLET_FETCH_STATE",
};
